<app-nav class="w-100"></app-nav>
<!-- <section class="banner"> -->
  <app-page-heading [heading]="currentItem?.type.arabic" [sub_heading]="currentItem?.name"
    [breadcrumbs]="getBreadcrumbs()" [type]="currentItem?.type.arabic"></app-page-heading>
  <!-- <div #air id="air" class="air kenburns-top"></div> -->
<!-- </section> -->
<app-skelitions [hidden]="!skelition" [value]="7"></app-skelitions>
<div class="container-fluid bg-lightt">
  <div class="container-fluid p-0 py-4 3333">
    <div class="row">
      <div class="col-md-12 col-12 my-2" *ngIf="
          !fetchingCurrent && currentItem && currentItem?.fields?.length > 0
        ">
        <div *ngIf="editFlag" class="row d-flex justify-content-between flex-start mob-flex-column mb-4">
          <!-- <h2 [innerHTML]="currentItem.name | highlight: searchQuery" class="card-title manage-margin"
                        style="font-weight: 600; color: var(--color-1)"></h2> -->

          <!-- New Changes -->
          <div class="col-md-8 col-12 d-flex my-2">
            <div *ngIf="hasPermission('CONTENT', 'u') && editPermission" class="d-flex align-items-center">
              <i [hidden]="editFlag == true" (click)="editFlag = true" class="pi pi-fw pi-pencil edit-btn"></i>
              <!-- <i [hidden]="editFlag==false" (click)="editFlag=false"
                                class="pi pi-times-circle edit-btn"></i> -->
            </div>
            <div class="column pos-rel w-100 1010">
              <h2 [hidden]="editFlag" class="card-title" [innerHTML]="currentItem.name | highlight : searchQuery"
                style="font-weight: 600; color: var(--color-1)"></h2>
              <!-- <label [hidden]="editFlag==false" class="name-position">العنوان</label> -->
              <input [hidden]="!editFlag" pInputText [(ngModel)]="currentItem.name" class="w-100 edit-input-ui"
                [id]="currentItem.name" type="text" />
            </div>
          </div>

          <div class="col-md-4 col-12">
            <div class="flex-end-mob-web">
              <span class="btn-flex mx-1">
                <span class="d-flex flex-column">
                  <span class="btn-css mx-2">{{
                    "Last updated" | translator
                    }}</span>
                  <span class="btn-css mx-2 font-0_8rem font-weight-200">{{
                    currentItem.updatedAt | date : "MMMM d, y | h:mm:ss a"
                    }}</span>
                </span>
                <span class="icon-box">
                  <i class="pi pi-calendar font-500"></i>
                </span>
              </span>
            </div>
          </div>
        </div>

        <p-messages [(value)]="messages" [enableService]="false"></p-messages>

        <!-- <div class="row" *ngIf="currentItem && currentItem.fields.length > 0">
                    <div *ngFor="let field of currentItem?.fields; let i = index">
                        
                        

                    </div>
                </div> -->

        <div class="1st_tag" *ngIf="!editFlag">
          <app-eservicepanelview [data]="currentItem.fields[0]" [item]="currentItem"></app-eservicepanelview>

          <div class="row mt-3 d-flex">
            <ng-container *ngFor="let field of filteredFields; let i = index">
              <div class="dashboard-btn">
                <div class="eService-mini-card d-flex flex-row align-items-center mb-3 ssssss">
                  <i [ngClass]="field.label?.icon + ' font-2_2 v4-color-white'" class="mx-4"></i>
                  <div class="d-flex flex-column justify-content-center">
                    <h5 class="v4-color-white d-btn-t-bold">{{ field.label.name }}</h5>
                    <p class="v4-color-white d-btn-t" [innerHTML]="field.data"></p>
                  </div>
                </div>
              </div>
            </ng-container>
          </div>
          
          <div class="row custom-gap-3">
            <div class="col-md-3 col-12">
              <div class="bg-content">
              <ng-container *ngFor="let field of remainingFields; let i = index">
                  <div (click)="selectedfield = field" [ngClass]="
                  selectedfield == field ? 'v4-activated' : 'v4-Dactivated'
                  " class="mt-2 p-2 d-flex align-items-center" style="cursor: pointer">
                  <div class="d-b-panel">
                    <i [ngClass]="field.label?.icon + ' font-1'" class="cust om-my-5 mx-3"></i>
                  </div>
                  <div>
                    <h5 class="d-btn-t-bold">{{ field.label.name }}</h5>
                  </div>
                </div>
              </ng-container>
            </div>
            </div>
            
            
            <div class="col-md-9 col-12" *ngIf="selectedfield">
              <div class="bg-content-1">
              <div style="min-height: 100%" class="my-2 px-2 d-flex flex-column">
                <div class="d-flex flex-row w-100">
                  <i [ngClass]="
                      selectedfield?.label?.icon + ' font-2_2 color-grey'
                    " class="m-l-2"></i>
                  <h4 class="color-grey">
                    {{ selectedfield?.label.name }}
                  </h4>
                </div>

                <div class="color-grey v4-word-break" [ngSwitch]="getFieldType(selectedfield?.label?.type)">
                  <!-- For text -->
                  <div *ngSwitchCase="'text'">
                    <div class="line-space mb-0 datacontent" *ngIf="selectedfield?.data" [innerHTML]="
                        selectedfield?.data | highlight : searchQuery | safeHTML
                      "></div>
                  </div>
                  <!-- Rich text -->
                  <div *ngSwitchCase="'Rich text'">
                    <div class="line-space mb-0 datacontent" *ngIf="selectedfield?.data" [innerHTML]="
                        selectedfield?.data | highlight : searchQuery | safeHTML
                      "></div>
                  </div>
                  <div *ngSwitchCase="'Upload Image'">
                    <img [hidden]="selectedfield?.data == ''" class="img-fluid upload-img" [src]="
                        GlobalConstants.staticFilesURL + selectedfield?.data
                      " />
                  </div>
                  <div *ngSwitchCase="'Upload Document'">
                    <a class="doc-view" [hidden]="selectedfield?.data == ''" target="_blank" [href]="
                        GlobalConstants.staticFilesURL + selectedfield?.data
                      ">
                      <i [hidden]="selectedfield?.data == ''" class="pi pi-file mx-2"></i>
                      {{ "Add a file" | translator }}
                    </a>
                  </div>
                  <div *ngSwitchCase="'Data Item'">
                    <p class="color-bold">{{ selectedfield?.data?.name }}</p>
                    <p-accordion class="w-full" [multiple]="true">
                      <p-accordionTab class="my-3" *ngFor="
                          let field of selectedfield?.data.fields;
                          let i = index
                        " iconPos="end">
                        <ng-template pTemplate="header">
                          <div class="d-flex align-items-center">
                            <i [ngClass]="field.label?.icon + ' font-1_2rem'" class="m-2"></i>
                            <span class="vertical-align-middle font-1_1rem">{{
                              field.label?.name
                              }}</span>
                          </div>
                        </ng-template>
                        <ng-template pTemplate="content">
                          <div class="row">
                            <div class="col-10">
                              <div [ngSwitch]="getFieldType(field.label?.type)">
                                <!-- For text -->
                                <div *ngSwitchCase="'text'">
                                  <div class="line-space mb-0 datacontent flex-column" *ngIf="field.data" [innerHTML]="
                                      field.data
                                        | highlight : searchQuery
                                        | safeHTML
                                    "></div>
                                </div>
                                <!-- Rich text -->
                                <div *ngSwitchCase="'Rich text'">
                                  <div class="line-space mb-0 datacontent flex-column" *ngIf="field.data" [innerHTML]="
                                      field.data
                                        | highlight : searchQuery
                                        | safeHTML
                                    "></div>
                                </div>
                                <div *ngSwitchCase="'Upload Image'">
                                  <img [hidden]="field.data == ''" class="img-fluid upload-img" [src]="
                                      GlobalConstants.staticFilesURL +
                                      field.data
                                    " />
                                </div>
                                <div *ngSwitchCase="'Upload Document'">
                                  <a class="doc-view" [hidden]="field.data == ''" target="_blank" [href]="
                                      GlobalConstants.staticFilesURL +
                                      field.data
                                    ">
                                    <i [hidden]="field.data == ''" class="pi pi-file mx-2"></i>{{ "Add a file" |
                                    translator }}
                                  </a>
                                </div>
                                <div *ngSwitchCase="'Data Item'"></div>
                                <div *ngSwitchDefault></div>
                              </div>
                            </div>
                          </div>
                        </ng-template>
                      </p-accordionTab>
                    </p-accordion>
                  </div>
                  <div *ngSwitchDefault></div>
                </div>
              </div>
            </div>
            </div>
          </div>
        </div>

        <p-accordion class="w-full" [multiple]="true" [activeIndex]="0"
          *ngIf="currentItem && currentItem.fields.length > 0">
          <span *ngFor="let field of currentItem?.fields; let i = index">
            <span *ngIf="field.data && field.data != '' && field.data != null">
              <p-accordionTab class="my-3" *ngIf="editFlag" iconPos="end" [selected]="i == 0 || i == 1">
                <ng-template pTemplate="header">
                  <div class="d-flex align-items-center">
                    <p-checkbox (click)="$event.stopPropagation()" [hidden]="!editFlag" [(ngModel)]="field.isChecked"
                      class="shadow" [binary]="true" inputId="binary"></p-checkbox>
                    <i [ngClass]="field.label?.icon + ' font-1_2rem'" class="m-2"></i>
                    <span class="vertical-align-middle font-1_1rem">{{
                      field.label?.name
                      }}</span>
                  </div>
                </ng-template>
                <ng-template pTemplate="content">
                  <span *ngIf="field?.data.length > 50 && i > 0">
                    <div *ngIf="!editFlag" class="row">
                      <!-- For View -->
                      <div class="col-12">
                        <div [ngSwitch]="getFieldType(field.label?.type)">
                          <!-- For text -->
                          <div *ngSwitchCase="'text'">
                            <div class="line-space mb-0 datacontent" *ngIf="field.data" [innerHTML]="
                                field.data | highlight : searchQuery | safeHTML
                              "></div>
                          </div>
                          <!-- Rich text -->
                          <div *ngSwitchCase="'Rich text'">
                            <div class="line-space mb-0 datacontent" *ngIf="field.data" [innerHTML]="
                                field.data | highlight : searchQuery | safeHTML
                              "></div>
                          </div>
                          <div *ngSwitchCase="'Upload Image'">
                            <img [hidden]="field.data == ''" class="img-fluid upload-img" [src]="
                                GlobalConstants.staticFilesURL + field.data
                              " />
                          </div>
                          <div *ngSwitchCase="'Upload Document'">
                            <a class="doc-view" [hidden]="field.data == ''" target="_blank" [href]="
                                GlobalConstants.staticFilesURL + field.data
                              ">
                              <i [hidden]="field.data == ''" class="pi pi-file mx-2"></i>{{ "Add a file" | translator }}
                            </a>
                          </div>
                          <div *ngSwitchCase="'Data Item'">
                            <p class="color-bold">{{ field?.data?.name }}</p>
                            <p-accordion class="w-full" [multiple]="true">
                              <p-accordionTab class="my-3" *ngFor="
                                  let field of field.data.fields;
                                  let i = index
                                " iconPos="end">
                                <ng-template pTemplate="header">
                                  <div class="d-flex align-items-center">
                                    <i [ngClass]="
                                        field.label?.icon + ' font-1_2rem'
                                      " class="m-2"></i>
                                    <span class="vertical-align-middle font-1_1rem">{{ field.label?.name }}</span>
                                  </div>
                                </ng-template>
                                <ng-template pTemplate="content">
                                  <div class="row">
                                    <div class="col-10">
                                      <div [ngSwitch]="
                                          getFieldType(field.label?.type)
                                        ">
                                        <!-- For text -->
                                        <div *ngSwitchCase="'text'">
                                          <div class="line-space mb-0 datacontent flex-column" *ngIf="field.data"
                                            [innerHTML]="
                                              field.data
                                                | highlight : searchQuery
                                                | safeHTML
                                            "></div>
                                        </div>
                                        <!-- Rich text -->
                                        <div *ngSwitchCase="'Rich text'">
                                          <div class="line-space mb-0 datacontent flex-column" *ngIf="field.data"
                                            [innerHTML]="
                                              field.data
                                                | highlight : searchQuery
                                                | safeHTML
                                            "></div>
                                        </div>
                                        <div *ngSwitchCase="'Upload Image'">
                                          <img [hidden]="field.data == ''" class="img-fluid upload-img" [src]="
                                              GlobalConstants.staticFilesURL +
                                              field.data
                                            " />
                                        </div>
                                        <div *ngSwitchCase="'Upload Document'">
                                          <a class="doc-view" [hidden]="field.data == ''" target="_blank" [href]="
                                              GlobalConstants.staticFilesURL +
                                              field.data
                                            ">
                                            <i [hidden]="field.data == ''" class="pi pi-file mx-2"></i>
                                            {{ "Add a file" | translator }}
                                          </a>
                                        </div>
                                        <div *ngSwitchCase="'Data Item'"></div>
                                        <div *ngSwitchDefault></div>
                                      </div>
                                    </div>
                                  </div>
                                </ng-template>
                              </p-accordionTab>
                            </p-accordion>
                          </div>
                          <div *ngSwitchDefault></div>
                        </div>
                      </div>
                    </div>
                  </span>

                  <div *ngIf="editFlag" class="d-flex justify-content-between">
                    <div class="w-100" [ngSwitch]="getFieldType(field.label?.type)">
                      <!-- For text -->
                      <div *ngSwitchCase="'text'">
                        <i class="pi pi-clone"></i>
                        <input pInputText [(ngModel)]="field.data" class="w-100" [id]="field.label" type="text" />
                      </div>
                      <!-- Rich text -->
                      <div *ngSwitchCase="'Rich text'">
                        <p-editor class="question-p-editor" [(ngModel)]="field.data" [style]="{ height: '320px' }"></p-editor>
                      </div>
                      <div *ngSwitchCase="'Upload Image'">
                        <img [hidden]="field.data == ''" class="img-fluid upload-img-dActive"
                          [src]="GlobalConstants.staticFilesURL + field.data" />
                        <p-fileUpload mode="basic" chooseLabel="Choose" name="file" [url]="apilink + 'file/data'"
                          [auto]="true" chooseLabel="Browse" accept="image/*" [maxFileSize]="1000000" (onUpload)="
                            field.data = $event.originalEvent.body.data
                          "></p-fileUpload>
                      </div>
                      <div *ngSwitchCase="'Upload Document'">
                        <a class="doc-view-dActive" [hidden]="field.data == ''" target="_blank"
                          [href]="GlobalConstants.staticFilesURL + field.data">
                          <i [hidden]="field.data == ''" class="pi pi-file mx-2"></i>
                          {{ "Add a file" | translator }}
                        </a>
                        <p-fileUpload mode="basic" chooseLabel="Choose" name="file" [url]="apilink + 'file/data'"
                          [auto]="true" chooseLabel="Add File" [maxFileSize]="100000000" (onUpload)="
                            field.data = $event.originalEvent.body.data
                          "></p-fileUpload>
                      </div>
                      <div *ngSwitchCase="'Data Item'">
                        <button type="submit" (click)="toggleModal(i)" pButton pRipple
                          label="{{ 'to update' | translator }}" icon="pi pi-fw pi-plus-circle"
                          class="w-full my-3"></button>
                        <p-dialog [blockScroll]="true" [draggable]="false"
                          header="{{ 'Select a service' | translator }}" [(visible)]="modalVisibilities[i]"
                          [style]="{ width: '70vw' }">
                          <app-select-service (currentDataItem)="
                              changeCurrentDataItem($event, field, i)
                            "></app-select-service>
                        </p-dialog>
                        <p class="font-bold" *ngIf="field.data">
                          {{ field.data.name }}
                        </p>
                      </div>
                      <div *ngSwitchDefault></div>
                    </div>
                  </div>
                </ng-template>
              </p-accordionTab>
            </span>
          </span>
        </p-accordion>
        <div class="flex-mob-web my-3">
          <ng-container *ngIf="hasUnitPermission('VIEW_SIGN', 'r')">
            <div (click)="changeModal(true)" *ngIf="
                !currentItem.signed || currentItem.signed.status == false;
                else signedTemplate
              " class="d-flex justify-content-start flex-start mob-flex-column">
              <div class="d-flex my-1">
                <span class="btn-flex mx-1">
                  <span class="d-flex flex-column">
                    <span *ngIf="!currentItem.signed.user_name" class="btn-css mx-2">{{
                      "Not approved by the expert" | translator
                      }}</span>
                    <ng-container *ngIf="currentItem.signed.user_name">
                      <span class="btn-css mx-2">{{ "not available for ministry page" | translator }} {{
                        currentItem.signed.user_name }}
                      </span>
                    </ng-container>
                  </span>
                  <span class="icon-box">
                    <i class="pi pi-exclamation-circle font-500"></i>
                  </span>
                </span>
              </div>
            </div>
            <ng-template #signedTemplate>
              <div (click)="changeModal(true)" class="d-flex justify-content-start flex-start mob-flex-column">
                <div class="d-flex my-1">
                  <span class="btn-flex mx-1">
                    <span class="d-flex flex-column">
                      <span class="btn-css mx-2">{{ "Approved by the expert" | translator }} :
                        {{ currentItem.signed.user_name }}</span>
                      <span class="btn-css mx-2 font-0_8rem font-weight-200">
                        {{ currentItem.signed.date | date : "MMMM,d, y" }}
                      </span>
                    </span>
                    <span class="icon-box">
                      <i class="pi pi-exclamation-circle font-500"></i>
                    </span>
                  </span>
                </div>
              </div>
            </ng-template>
          </ng-container>
          <app-sign-history [dataId]="currentItem._id" [visible]="openSignModal"
            (close)="changeModal(false)"></app-sign-history>

          <div class="flex-end-mob-web my-1">
            <span pTooltip="{{ 'Delete' | translator }}" tooltipPosition="top"
              *ngIf="hasUnitPermission('CONTENT', 'd') && deletePermission && hasEditPermissionWithType()"
              class="Ersaal-danger-btn mx-1 p-3" (click)="updateReasonModal(true)">
              <i class="pi pi-trash font-500 font-1_2rem"></i>
            </span>
            <button pTooltip="{{ 'Print' | translator }}" tooltipPosition="top" class="btn-flex mx-1 p-3"
              [useExistingCss]="true" styleSheetFile="search-result.component.scss" [printStyle]="{
                '#print-data': { display: 'block' },
                '*': { direction: 'rtl' },
                html: { direction: 'rtl' },
                body: { direction: 'rtl' }
              }" printSectionId="print-data" ngxPrint>
              <i class="pi pi-print font-500 font-1_2rem"></i>
            </button>
            <span pTooltip="{{ 'Copy Link' | translator }}" tooltipPosition="top" class="btn-flex mx-1 p-3"
              (click)="copyLinkToClipboard()">
              <i class="pi pi-link font-500 font-1_2rem"></i>
            </span>
            <span pTooltip="{{ 'EDIT' | translator }}" tooltipPosition="top" [hidden]="editFlag == false" class="mx-1"
              *ngIf="hasPermission('CONTENT', 'u') && editPermission && hasEditPermissionWithType()">
              <button class="btn-flex-3 123" (click)="updateReasonModal()">
                <i class="pi pi-check m-l-2"></i>{{ "OK" | translator }}
              </button>
            </span>

            <span class="mx-1">
              <button pTooltip="{{ 'EDIT' | translator }}" tooltipPosition="top"
                *ngIf="hasPermission('CONTENT', 'u') && editPermission && hasEditPermissionWithType()" [ngClass]="
                  editFlag == true ? 'Ersaal-danger-btn 22' : 'btn-flex-3 33'
                " (click)="editFlag = !editFlag">
                <i *ngIf="editFlag == false" class="pi pi-pencil"></i>
                <i *ngIf="editFlag == true" class="pi pi-times-circle"></i>
              </button>
            </span>

            <span *ngIf="isLoggedIn" pTooltip="{{ 'Favorite' | translator }}" tooltipPosition="top" class="mx-1">
              <button class="Ersaal-btn" (click)="updateFavourite()">
                <i class="{{isFavorite() ? 'fa-solid fa-star':'fa-regular fa-star'}}"></i>
              </button>
            </span>


          </div>
        </div>
      </div>
      <div class="col-md-8 col-12 my-2 d-flex align-items-center justify-content-center" style="height: 30rem"
        *ngIf="fetchingCurrent">
        <p-progressSpinner></p-progressSpinner>
      </div>
      <div class="col-md-8 col-12 my-2" *ngIf="
          !fetchingCurrent &&
          (currentItem == undefined ||
            currentItem == null ||
            currentItem?.fields?.length == 0)
        ">
        <app-no-data></app-no-data>
      </div>
    </div>
  </div>
</div>

<!-- Printing Service Use Only -->
<div style="display: none; width: 100%" id="print-data" *ngIf="currentItem && currentItem?.fields.length > 0">
  <h2 [hidden]="editFlag" class="card-title" style="font-weight: 600; color: var(--color-1); margin-bottom: 2rem">
    {{ currentItem.name }}
  </h2>

  <div class="d-flex flex-row w-100 left-0 pb-2 wrapp">
    <ng-container *ngIf="
        currentItem &&
        currentItem.breadcrumbs &&
        currentItem.breadcrumbs.length > 0
      ">
      <span class="d-flex flex-row align-items-center" *ngFor="let parent of sortByDepth(currentItem?.breadcrumbs)">
        <span class="btn-flex custom-bredcrum-btn ou-item align-items-center" style="background-color: grey">
          <span class="btn-css mx-2 font-0_5rem" role="button" [routerLink]="'/category/' + parent.id">{{ parent.label
            }}</span>
          <span class="icon-box" style="background-color: grey">
            <img src="{{ staticURL + parent?.icon }}" *ngIf="checkisImg(parent?.icon); else elseBlock" class="img-fluid"
              alt="" />
            <ng-template #elseBlock>
              <i class="pi pi-{{ parent.icon }} img-fluid"></i>
            </ng-template>
          </span>
        </span>
        <span>
          <i class="pi pi-fw pi-angle-left"></i>
        </span>
      </span>
    </ng-container>
    <span style="background-color: grey"
      class="my-1 btn-flex mx-1 ou-item active custom-bredcrum-btn align-items-center">
      <span role="button" class="btn-css mx-2 font-0_5rem" [routerLink]="'/category/' + currentItem?.id">{{
        currentItem?.name }}</span>
      <span class="icon-box" style="background-color: grey">
        <img src="{{ staticURL + currentItem?.image_sq }}" *ngIf="checkisImg(currentItem?.image_sq); else elseBlock"
          class="img-fluid" alt="" />
        <ng-template #elseBlock>
          <i class="pi pi-{{ currentItem?.image }} align-self-center"></i>
        </ng-template>
      </span>
    </span>
  </div>

  <div style="margin: 1rem 0"></div>
  <span class="hr"></span>

  <div *ngFor="let field of currentItem?.fields; let i = index">
    <div class="d-flex align-items-center">
      <i [ngClass]="field.label?.icon + ' font-1_2rem'" style="color: #27306f; font-weight: 800" class="m-2"></i>
      <h3 class="vertical-align-middle font-1_1rem" style="color: #27306f; font-weight: 800">
        {{ field.label?.name }}
      </h3>
    </div>

    <div class="row" style="margin: 0.5rem 1rem">
      <!-- For View -->
      <div class="col-12">
        <div [ngSwitch]="getFieldType(field.label?.type)">
          <!-- For text -->
          <div *ngSwitchCase="'text'">
            <div class="line-space mb-0 datacontent" *ngIf="field.data" [innerHTML]="field.data | safeHTML"></div>
          </div>
          <!-- Rich text -->
          <div *ngSwitchCase="'Rich text'">
            <div class="line-space mb-0 datacontent" *ngIf="field.data" [innerHTML]="field.data | safeHTML"></div>
          </div>
          <div *ngSwitchCase="'Upload Image'">
            <img [hidden]="field.data == ''" class="img-fluid upload-img"
              [src]="GlobalConstants.staticFilesURL + field.data" />
          </div>
          <div *ngSwitchCase="'Upload Document'">
            <a class="doc-view" [hidden]="field.data == ''" target="_blank"
              [href]="GlobalConstants.staticFilesURL + field.data">
              <i [hidden]="field.data == ''" class="pi pi-file mx-2"></i>{{ "Add file" | translator }}
            </a>
          </div>
          <div *ngSwitchCase="'Data Item'" style="padding: 20px; margin: 20px">
            <p class="color-bold" style="color: #27306f">
              {{ field?.data?.name }}
            </p>

            <div class="my-3" *ngFor="let field of sortFiled(field.data.fields); let i = index" iconPos="end">
              <div class="d-flex align-items-center" style="padding: 10px; margin: 10px">
                <i [ngClass]="field.label?.icon + ' font-1_2rem'" style="color: #27306f; font-weight: 800"
                  class="m-2"></i>
                <span class="vertical-align-middle font-1_1rem" style="color: #27306f; font-weight: 800">{{
                  field.label?.name }}</span>
              </div>

              <div class="row">
                <div class="col-10">
                  <div [ngSwitch]="getFieldType(field.label?.type)">
                    <!-- For text -->
                    <div *ngSwitchCase="'text'">
                      <div class="line-space mb-0 datacontent flex-column" *ngIf="field.data"
                        [innerHTML]="field.data | safeHTML"></div>
                    </div>
                    <!-- Rich text -->
                    <div *ngSwitchCase="'Rich text'">
                      <div class="line-space mb-0 datacontent flex-column" *ngIf="field.data"
                        [innerHTML]="field.data | safeHTML"></div>
                    </div>
                    <div *ngSwitchCase="'Upload Image'">
                      <img [hidden]="field.data == ''" class="img-fluid upload-img"
                        [src]="GlobalConstants.staticFilesURL + field.data" />
                    </div>
                    <div *ngSwitchCase="'Upload Document'">
                      <a class="doc-view" [hidden]="field.data == ''" target="_blank"
                        [href]="GlobalConstants.staticFilesURL + field.data">
                        <i [hidden]="field.data == ''" class="pi pi-file mx-2"></i>{{ "Add file" | translator }}
                      </a>
                    </div>
                    <div *ngSwitchCase="'Data Item'"></div>
                    <div *ngSwitchDefault></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div *ngSwitchDefault></div>
        </div>
      </div>
    </div>
  </div>
</div>

<p-toast></p-toast>

<!-- Confirm Modal -->
<p-confirmDialog #cd [style]="{ width: '50vw' }">
  <ng-template pTemplate="footer">
    <button type="button" pButton icon="pi pi-times" label="{{ 'cancellation' | translator }}"
      (click)="cd.reject()"></button>
    <button type="button" pButton icon="pi pi-check" label="{{ 'OK' | translator }}" (click)="cd.accept()"></button>
      </ng-template>
</p-confirmDialog>


<!-- Update Reason modal -->
<div class="card flex justify-content-center">
  <p-dialog [blockScroll]="true" [draggable]="false" header="{{ 'the reason' | translator }}" [(visible)]="reasonModal"
    [style]="{ margin: '0rem 1rem', width: '95vw', maxWidth: '600px' }" [maximizable]="true">
    <div class="w-100">
      <p>{{ "the reason" | translator }}</p>
      <p-editor class="question-p-editor-2" [(ngModel)]="reasonHolder" [style]="{ height: '320px' }">
      </p-editor>
      <p *ngIf="reasonError" style="color: red">{{ 'Please Write a reason for update' }}</p>
    </div>
    <ng-template pTemplate="footer">
      <button class="v4-btn-every py-2" (click)="updateData()"><i class="pi pi-check v4-ml-2"></i>{{ 'OK' | translator
        }}</button>
    </ng-template>
  </p-dialog>
</div>

<app-footer></app-footer>